export const ERROR_CODES = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED'
};
